import { Box, styled, Tooltip, Typography } from '@mui/material';

import { ContentItem } from './sections/ContentItem';
import { DesktopFrame } from './sections/DesktopFrame';
import { TooltipContent } from './sections/TooltipContent';
import { GuideStyle } from './styles/guideStyles';

export interface GuideArea {
  id: string;
  label: string;
  description: string;
  x: string | number;
  y: string | number;
  width: string | number;
  height: string | number;
  fieldName: string;
  fontSize?: string;
  style?: GuideStyle;
  showBadge?: boolean;
}

interface ServiceGuideProps {
  areas: GuideArea[];
}

const ServiceGuide = ({ areas }: ServiceGuideProps) => {
  return (
    <Box>
      <GuideTitle variant="h5">Layout Guide</GuideTitle>
      <DesktopFrame>
        {/* 컨텐츠 프레임*/}
        <Box
          sx={{
            height: '400px',
            position: 'relative',
          }}
        >
          {/* 컨텐츠 내용 */}
          {areas.map((area) => {
            return (
              <GuideAreaBox key={area.id} area={area}>
                {/* 컨텐츠 선택 시 설명 노출 */}
                <Tooltip
                  title={<TooltipContent label={area.label} description={area.description} />}
                  arrow
                  placement="right"
                >
                  {/* 컨텐츠 */}
                  <div style={{ width: '100%', height: '100%' }}>
                    <ContentItem
                      area={area}
                      showBadge={area.showBadge}
                      contentStyle={{
                        alignItems: area.id === 'bgPath' ? 'flex-start' : 'center',
                        justifyContent: area.id === 'bgPath' ? 'left' : 'center',
                      }}
                    />
                  </div>
                </Tooltip>
              </GuideAreaBox>
            );
          })}
        </Box>
      </DesktopFrame>
    </Box>
  );
};

export default ServiceGuide;

export const ServicePreview = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.neutral,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
  transition: 'all 0.3s ease',
}));

const GuideTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(3),
  position: 'relative',
  paddingBottom: theme.spacing(1),
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '40px',
    height: '3px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  },
}));
interface GuideAreaBoxProps {
  area: GuideArea;
  selected?: boolean;
}

export const GuideAreaBox = styled(Box, {
  // area, selected props는 DOM에 전달하지 않도록 예외
  shouldForwardProp: (prop) => prop !== 'area' && prop !== 'selected',
})<GuideAreaBoxProps>(({ theme, area, selected }) => ({
  position: 'absolute',
  left: area.x,
  top: area.y,
  width: area.width,
  height: area.height,
  ...area.style,
  transition: 'all 0.3s ease',
  border: `2px dashed ${theme.palette.divider}`,
  '&:hover': {
    transform: 'scale(1.01)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    backgroundColor: `${theme.palette.background.paper}20`,
  },
}));
